export default [
    "#EC853B",
    "#EBC950",
    "#56CFC7",
    "#8DE557",
    "#F2F0E9",
    "#1FAFD4",
    "#CA4EE9",
    "#D41C75",
    "#EC3B3B",
    "#485CC7",
    "#9747FF",
    "#2277EE",
]
